export default __webpack_public_path__ + "e86b6ea33afd45dcfeb127a65ac39359.svg";